import React from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import servicioHttp from '../servicio/ServicioHttp';
import { Growl } from "primereact/growl";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import servicioObjetos from '../servicio/ServicioObjetos';
import { Message } from 'primereact/message';
import { Calendar } from 'primereact/calendar';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';
import servicioFormatos from '../servicio/ServicioFormatos';

const MENSAJE_REQUERIDO = "Información requerida";
export class Uma extends React.Component {


    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 30 },
            uma: {},
            errores: {},
            mostrarDialogAgregar: false,
            mostrarDialogEditar: false,
            mostrarDialogEliminar: false,
            desarrollador: false
        };
    }

    componentDidMount() {
        this.uma();
        this.obtnerUsuarioDesarrollador();
    }

    obtnerUsuarioDesarrollador = () => {
        servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
            if (response.data.mensaje === "existe") {
                this.setState({ desarrollador: true });
            }
        }).catch(error => {
        });
    }

    uma = () => {
        servicioHttp.consumirPostHttp("uma/consulta_uma.json").then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {
        });
    }

    mostrarModalAgregar = () => {
        this.setState({ mostrarDialogAgregar: true });
    };

    mostrarModalEditar = () => {
        this.setState({ mostrarDialogEditar: true });
    };

    cerrarModalAgregar = () => {
        this.setState({
            mostrarDialogAgregar: false
        });
        this.reset();
    }

    cerrarModalEditar = () => {
        this.setState({
            mostrarDialogEditar: false
        });
        this.reset();
    }

    actualizar(rowData) {
        var umaEditar = JSON.parse(JSON.stringify(rowData));
        let fechaInicio = new Date(umaEditar.fechaInicio);
        umaEditar.fechaInicio = fechaInicio;
        this.setState({ mostrarDialogEditar: true, uma: umaEditar });
    }

    editarUma = () => {
        let { uma } = this.state;
        let validForm = this.validarFormulario(uma);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            servicioHttp.consumirPostHttp("uma/actualizar_uma.json", uma).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalEditar();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    eliminar = () => {
        let { uma } = this.state;
        servicioHttp.consumirPostHttp("uma/eliminar_uma.json", uma).then(response => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.componentDidMount();
            this.cerrarModalEliminar();
        }).catch(error => {
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        })
    }

    reset = () => {
        this.setState({
            uma: {},
            errores: {}
        });
    }

    mostrarModalAgregar = () => {
        this.setState({ mostrarDialogAgregar: true });
    };

    cerrarModalAgregar = () => {
        this.setState({
            mostrarDialogAgregar: false
        });
        this.reset();
    }

    mostrarModalEditar = () => {
        this.setState({ mostrarDialogEditar: true });
    };

    cerrarModalEditar = () => {
        this.setState({
            mostrarDialogEditar: false
        });
        this.reset();
    }

    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarModalEliminar: true, uma: objeto });
    }

    cerrarModalEliminar = () => {
        this.setState({ mostrarModalEliminar: false });
        this.reset();
    }

    asignaValor = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    };

    guardarUma = () => {
        let { uma } = this.state;
        let guardaUma = { ...uma };
        let validForm = this.validarFormulario(guardaUma);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            guardaUma.fechaInicio = uma.fechaInicio;
            guardaUma.valorUma = uma.valorUma;
            servicioHttp.consumirPostHttp("uma/guardar_uma.json", guardaUma).then((response) => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalAgregar();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    validarFormulario = (uma) => {
        let errores = {};

        if (servicioObjetos.esObjetoVacio(uma.fechaInicio)) {
            errores.fechaInicio = MENSAJE_REQUERIDO;
        }
        if (servicioObjetos.esObjetoVacio(uma.valorUma)) {
            errores.valorUma = MENSAJE_REQUERIDO;
        }
        return errores;
    }

    plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.actualizar(column.rowData)}
                    className="p-button-warning" name="editar" tooltip="Editar información">
                </Button>
            </div>
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(column.rowData)}
                    className="p-button-danger" name="eliminar" tooltip="Eliminar registro" >
                </Button>
            </div>
        </div>;
    }

    reset = () => {
        this.setState({
            uma: {},
            errores: {}
        });
    }

    formatearColumnaFecha = (data, rowColumn) => {
        return <div>{servicioFormatos.formatearFechaTablas(data.fechaInicio)}</div>;
    }

    render() {
        let { paginacion, errores, uma, mostrarDialogAgregar, mostrarDialogEditar, desarrollador } = this.state;
        let pieTablaBotones = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-5">
                {desarrollador ?
                    <Button className="p-button-secondary" type="button" name="agregarEjercicio" label="Agregar Ejercicio" tooltip="Agregar Ejercicio" onClick={this.mostrarModalAgregar}></Button>
                    : null}
            </div>
        </div>;
        const pieDialogoExaminar = (
            <div>
                <Button icon="pi-md-save" onClick={this.guardarUma} label="Guardar" />
                <Button icon="pi-md-close" onClick={this.cerrarModalAgregar} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogo = (
            <div>
                <Button icon="pi-md-check" onClick={this.editarUma} label="Aceptar" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEditar} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminar} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        return (

            <div className="p-grid">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title">
                    <div className="p-fluid p-grid">
                        <div className="p-col-12 p-md-12">
                            <h1>UNIDAD DE MEDIDA Y ACTUALIZACIÓN</h1>
                        </div>

                        <div className="p-col-12 p-md-12">
                            <label></label>
                        </div>

                        <div className="p-col-12 p-md-3">
                            <label></label>
                        </div>
                        <div className="col-12 p-md-6">
                            <DataTable footer={pieTablaBotones} value={paginacion.datos} header="UMA" responsive={true} paginator={true} rows={8}>
                                <Column header="FECHA INICIO" body={this.formatearColumnaFecha} autolayout={true} style={{ width: "70%" }} />
                                <Column header="VALOR UMA" field="valorUma" autolayout={true} style={{ width: "70%" }} />
                                {desarrollador === true ?
                                    <Column header="OPCIONES" body={this.plantillaOpciones} autolayout={true} style={{ width: "40%" }} />
                                    : null}
                            </DataTable>
                        </div>

                        <Dialog style={{ width: '60%', height: '35%' }} appendTo={document.body} header="Agregar registro - UMA" visible={mostrarDialogAgregar}
                            modal={true} onHide={this.cerrarModalAgregar} footer={pieDialogoExaminar}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label style={{ width: "50%" }}><strong>*Fecha Inicio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <Calendar appendTo={document.body} id="uma.fechaInicio" name="uma.fechaInicio" placeholder="DD/MM/YYYY"
                                        value={uma.fechaInicio || ''} onChange={(e) => this.asignaValor(e, false)}
                                        style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR}
                                        locale={CALENDARIO_ES_MX}></Calendar>
                                    {errores.fechaInicio ? <Message severity="error" text={errores.fechaInicio} /> : null}
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label style={{ width: "20%" }}><strong>*Valor UMA:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="uma.valorUma" name="uma.valorUma" value={uma.valorUma || ""}
                                        className={errores.uma ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                    {errores.valorUma ? <Message severity="error" text={errores.valorUma} /> : null}
                                </div>
                            </div>
                        </Dialog>
                        <Dialog style={{ width: '60%', height: '35%' }} appendTo={document.body} header="Editar registro - UMA" visible={mostrarDialogEditar}
                            modal={true} onHide={this.cerrarModalEditar} footer={pieDialogo}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label style={{ width: "50%" }}><strong>*Fecha Inicio:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <Calendar appendTo={document.body} id="uma.fechaInicio" name="uma.fechaInicio" placeholder="DD/MM/YYYY"
                                        value={uma.fechaInicio || ''} onChange={(e) => this.asignaValor(e, false)}
                                        style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR}
                                        locale={CALENDARIO_ES_MX}></Calendar>
                                    {errores.fechaInicio ? <Message severity="error" text={errores.fechaInicio} /> : null}
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label style={{ width: "20%" }}><strong>*Valor UMA:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="uma.valorUma" name="uma.valorUma" value={uma.valorUma || ""}
                                        className={errores.valorUma ? "p-error" : ""} placeholder="Valor" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="8" style={{ width: "100%" }} keyfilter="num" />
                                    {errores.valorUma ? <Message severity="error" text={errores.valorUma} /> : null}
                                </div>
                            </div>
                        </Dialog>
                        <Dialog style={{ width: '50%', height: '30%' }} header="Eliminar registro - UMA" visible={this.state.mostrarModalEliminar} modal={true}
                            footer={pieDialogEliminar} onHide={this.cerrarModalEliminar}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <center><h2><strong>¿Estás seguro de eliminar este registro?</strong></h2></center>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }
}